import React, { useEffect, useState } from 'react'
import * as AnalyticsService from '../../services/analytics'
import { useAnalyticsFilters } from '../../contexts/AnalyticsFilterContext'
import AnalyticsPageShell from './components/AnalyticsPageShell'
import MetricsSection from './components/MetricsSection'
import InsightsPanel from './components/InsightsPanel'
import SeriesChart from './components/SeriesChart'
import FunnelView from './components/FunnelView'
import { formatGranularity, getAnalyticsErrorMessage } from './utils'

const ExecutiveDashboard = () => {
    const { filters, rangeFilters, granularity } = useAnalyticsFilters()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [dashboard, setDashboard] = useState(null)
    const [timeline, setTimeline] = useState(null)
    const [funnel, setFunnel] = useState(null)

    useEffect(() => {
        let cancelled = false

        async function load() {
            setLoading(true)
            setError(null)
            try {
                const [dashboardData, timelineData, funnelData] = await Promise.all([
                    AnalyticsService.getDashboard(rangeFilters),
                    AnalyticsService.getTimeline(filters),
                    AnalyticsService.getFunnel(rangeFilters)
                ])
                if (cancelled) return
                setDashboard(dashboardData)
                setTimeline(timelineData)
                setFunnel(funnelData)
            } catch (err) {
                if (!cancelled) setError(getAnalyticsErrorMessage(err))
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        load()
        return () => {
            cancelled = true
        }
    }, [filters, rangeFilters])

    return (
        <AnalyticsPageShell
            title='Análises de negócio — Visão executiva'
            loading={loading}
            error={error}
            showGranularity
            showWorkshopId
        >
            <MetricsSection title='Inventário (estado atual)' metrics={dashboard?.inventory} />
            <MetricsSection title='Atividade no período (eventos)' metrics={dashboard?.activity} />
            <InsightsPanel insights={dashboard?.insights} title='Observações do painel' />
            <SeriesChart
                title={`Linha do tempo (${formatGranularity(timeline?.granularity || granularity)})`}
                series={timeline?.series}
            />
            <InsightsPanel insights={timeline?.insights} title='Observações da linha do tempo' />
            <FunnelView steps={funnel?.steps} />
            <InsightsPanel insights={funnel?.insights} title='Observações do funil' />
        </AnalyticsPageShell>
    )
}

export default ExecutiveDashboard
